<template>
  <div>
    <ul class="heading-ul mt-4 ml-10">
      <li>
        <router-link to="/businessEntity" class="vx-row">
          <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
          <h4>{{ $t("entity.label.edit_business_entity") }}</h4>
        </router-link>
      </li>
    </ul>
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      stepSize="xs"
      shape="circle"
      finishButtonText="Submit"
      @on-complete="updateEntity"
      ref="wizard"
    >
      <tab-content
        :title="$t('entity.label.business_entity_info')"
        :icon="tabIndex > 0 ? 'feather icon-check' : ''"
      >
        <!-- tab 1 content -->
        <ValidationObserver ref="observerOne">
          <vx-card class="form-padding">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.business_entity_opened_on")
                    }}<span class="required">*</span></small
                  >
                  <datepicker
                    :placeholder="$t('placeholder.label.SelectDate')"
                    v-model="entity.openingDate"
                    class="mb-2 font-semibold"
                  />
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.business_entity_type")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.business_entity_type')"
                  >
                    <v-select
                      label="name"
                      v-model="entity.officeType"
                      :options="entityTemplate.officeTypes"
                      :reduce="(name) => name.name"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.name
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.business_entity_name')"
                >
                  <vs-input
                    :label="$t('entity.label.business_entity_name')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.name"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.relationship_type")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.relationship_type')"
                  >
                    <v-select
                      label="mCodeValue"
                      v-model="entity.businessType"
                      :options="entityTemplate.businessTypes"
                      :reduce="(mCodeValue) => mCodeValue.id"
                      :placeholder="$t('entity.label.SelectSearch')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.mCodeValue
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.parent_business_entity")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.parent_business_entity')"
                  >
                    <v-select
                      label="name"
                      v-model="entity.parentId"
                      :options="parentEntities"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(name) => name.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.name
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full"></div>
            </div>
          </vx-card>
        </ValidationObserver>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content
        :title="$t('entity.label.company_info')"
        :icon="tabIndex > 1 ? 'feather icon-check' : ''"
      >
        <ValidationObserver ref="observerTwo">
          <vx-card class="form-padding">
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/4 md:w-1/4 sm:w-full xs:w-full"
                  >
                    <vs-upload
                      text="Company Logo"
                      limit="1"
                      :show-upload-button="true"
                      class="compose-mail-attachment"
                      @change="this.profileUrl = this.$refs.docFile.files[0]"
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-3/4 md:w-3/4 sm:w-full xs:w-full"
                  >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('entity.label.company_reg_no')"
                    >
                      <vs-input
                        :label="$t('entity.label.company_reg_no')"
                        class="w-full mb-2 starlabel"
                        v-model="entity.companyRegNo"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                    <div style="height: 20px"></div>
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.payment_type")
                        }}<span class="required">*</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('entity.label.payment_type')"
                      >
                        <v-select
                          label="item"
                          v-model="entity.payment"
                          :options="entityTemplate.paymentTypeEnum"
                          :placeholder="$t('entity.label.SelectSearch')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        >
                          <template v-slot:option="option">{{
                            option.item
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required|email"
                  v-slot="{ errors }"
                  :name="$t('entity.label.email')"
                >
                  <vs-input
                    :label="$t('entity.label.email')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.email"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <div style="height: 20px"></div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.address_name')"
                >
                  <vs-input
                    :label="$t('entity.label.address_name')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.addressName"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.segment_type")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.segment_type')"
                  >
                    <v-select
                      label="name"
                      v-model="entity.dasType"
                      :options="entityTemplate.segmentTypes"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(name) => name.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.name
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>

                <vs-input
                  :label="$t('entity.label.district')"
                  class="w-full"
                  readonly
                  value="cityTemplate.district"
                  v-model="entity.district"
                  disabled
                />
                <div style="height: 20px"></div>
                <vs-input
                  :label="$t('entity.label.state')"
                  class="w-full"
                  readonly
                  value="cityTemplate.state"
                  v-model="entity.state"
                  disabled
                />
                <div style="height: 20px"></div>
                <vs-input
                  :label="$t('entity.label.country')"
                  class="w-full"
                  readonly
                  value="cityTemplate.country"
                  v-model="entity.country"
                  disabled
                />
                <div style="height: 30px"></div>

                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.contact_person')"
                >
                  <vs-input
                    :label="$t('entity.label.contact_person')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.contactPerson"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <div style="height: 20px"></div>
                <ValidationProvider
                  rules="required|digits:10"
                  v-slot="{ errors }"
                  :name="$t('entity.label.phone_number')"
                >
                  <vs-input
                    :label="$t('entity.label.phone_number')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.phoneNumber"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <div style="height: 20px"></div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.pan_card_no')"
                >
                  <vs-input
                    :label="$t('entity.label.pan_card_no')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.pancardNo"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <div style="height: 20px"></div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.gst_reg_no')"
                >
                  <vs-input
                    :label="$t('entity.label.gst_reg_no')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.gstRegNo"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <div style="height: 20px"></div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.zip_code')"
                >
                  <vs-input
                    :label="$t('entity.label.zip_code')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.zip"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.city_area")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.city_area')"
                  >
                    <v-select
                      label="item"
                      v-model="entity.city"
                      :options="entityTemplate.addressData.cityData"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      @input="handlerCityChange"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.item
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div style="height: 20px"></div>
                <iframe
                  id="map"
                  width="100%"
                  height="406"
                  style="border: 0"
                  loading="lazy"
                  allowfullscreen
                  referrerpolicy="no-referrer-when-downgrade"
                  :src="`https://www.google.com/maps?q=${entity.city}&output=embed`"
                >
                </iframe>

                <vs-checkbox
                  class="mt-3 font-semibold"
                  v-model="entity.subscriberdues"
                  >{{ $t("entity.label.subscriber_dues") }}</vs-checkbox
                >
                <div style="height: 20px"></div>
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.commission_model")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.commission_model')"
                  >
                    <v-select
                      label="item"
                      v-model="entity.commisionModel"
                      :options="commissionModalItem"
                      :reduce="(obj) => obj.value"
                      :placeholder="$t('placeholder.label.SelectSearch')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.item
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div style="height: 20px"></div>
              </div>
            </div>
          </vx-card>
        </ValidationObserver>
      </tab-content>
      <tab-content
        :title="$t('entity.label.done')"
        :icon="tabIndex > 1 ? 'feather icon-check' : ''"
      >
        <vx-card class="form-padding">
          <div style="height: 20px"></div>
          <vs-row justify="center">
            <div style="margin-left: auto; margin-right: auto">
              <img
                src="@/assets/images/pages/success.png"
                style="width: 400px"
              />
            </div>
          </vs-row>
          <div class="center success-msg">
            {{ $t("entity.label.successfully_edited_business_entity") }}
          </div>
          <vs-row justify="center">
            <div style="margin-left: auto; margin-right: auto">
              <vs-button @click="$router.push('/businessEntity')">
                {{ $t("entity.label.go_back_to_business_entity_list") }}
              </vs-button>
            </div></vs-row
          >
        </vx-card>
      </tab-content>
      <template slot="footer" slot-scope="props">
        <div class="wizard-footer-left"></div>
        <div class="wizard-footer-right"></div>
        <div class="center">
          <vs-button
            class="footerButton-cancel"
            v-if="props.activeTabIndex == 0"
            type="border"
            @click="$router.push('/businessEntity')"
            >{{ $t("entity.label.cancel") }}</vs-button
          >
          <vs-button
            class="footerButton-cancel"
            v-if="props.activeTabIndex > 0 && !props.isLastStep"
            @click.native="props.prevTab()"
            type="border"
            >{{ $t("entity.label.previous") }}</vs-button
          >
          <vs-button
            class="footerButton-next"
            v-if="props.activeTabIndex == 0"
            @click.native="validateOne()"
            :style="props.fillButtonStyle"
          >
            {{
              props.isLastStep
                ? $t("entity.label.done")
                : $t("entity.label.next")
            }}</vs-button
          >
          <vs-button
            class="footerButton-next"
            v-if="props.activeTabIndex == 1"
            @click.native="validateTwo()"
            :style="props.fillButtonStyle"
            >{{ $t("entity.label.submit") }}</vs-button
          >
        </div>
      </template>
    </form-wizard>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { concat } from "lodash";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { mapState } from "vuex";

const entityEmptyObj = {
  name: "",
  officeType: "",
  parentId: null,
  businessType: "",
  contactPerson: "",
  phoneNumber: "",
  pancardNo: "",
  gstRegNo: "",
  commisionModel: "",
  subscriberdues: false,
  email: "",
  addressName: "",
  city: "",
  state: "",
  country: "",
  district: "",
  zip: "",
  companyRegNo: "",
  payment: "",
  dasType: "",
  clientData: {},
  locale: "en",
  externalId: "",
  dateFormat: "dd MMMM yyyy",
  openingDate: moment().format("DD MMMM YYYY"),
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      entity: entityEmptyObj,
      parentEntities: [],
      commissionModalItem: [
        { item: "Postpaid", value: 0 },
        { item: "Prepaid", value: 1 },
      ],
      id: "",
      tabIndex: 0,
    };
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      cityTemplateData: (state) => state.entity.cityTemplate,
      entityData: (state) => state.entity.entityDetail,
      updateResponse: (state) => state.entity.updateEntityResponse,
    }),

    entityTemplate() {
      return this.$store.getters["entity/template"];
    },
    cityTemplates() {
      return this.$store.getters["entity/getCityTemplate"];
    },
  },
  methods: {
    async validateOne() {
      const isValid = await this.$refs.observerOne.validate();
      if (!isValid) return;

      this.nextTab();
    },
    async validateTwo() {
      const isValid = await this.$refs.observerTwo.validate();
      if (!isValid) return;

      this.updateEntity();
    },
    nextTab() {
      this.tabIndex = this.$refs.wizard.activeTabIndex + 1;
      this.$refs.wizard.nextTab();
    },
    async getTemplate() {
      try {
        await this.$store.dispatch("entity/setTemplate");
        this.getEntity();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async cityTemplate() {
      try {
        await this.$store.dispatch("entity/setCityTemplate", this.entity.city);
        this.entity.district = this.cityTemplateData.district;
        this.entity.state = this.cityTemplateData.state;
        this.entity.country = this.cityTemplateData.country;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateEntity() {
      this.entity.dateFormat = "dd MMMM yyyy";
      this.entity.locale = "en";
      let tempdate = this.entity.openingDate;

      this.entity.openingDate = moment(tempdate).format("DD MMMM YYYY");
      delete this.entity.parentName;
      delete this.entity.balance;
      delete this.entity.id;
      delete this.entity.nameDecorated;
      delete this.entity.hierarchy;
      delete this.entity.clientId;
      delete this.entity.clientServiceId;
      delete this.entity.DocumentId;
      delete this.entity.credit;
      delete this.entity.allowedParents;
      delete this.entity.businessTypes;
      delete this.entity.segmentTypes;
      delete this.entity.officeNumber;
      delete this.entity.paymentTypeEnum;
      delete this.entity.officeTypes;
      const address = {
        addressNo: this.entity.addressName,
        city: this.entity.city,
        state: this.entity.state,
        country: this.entity.country,
        district: this.entity.district,
        zipCode: this.entity.zip,
      };
      const clientData = {
        entryType: "IND",
        clientCategory: 20,
        officeId: this.entity.parentId,
        title: "Mr",
        lastname: ".",
        firstname: this.entity.contactPerson,
        phone: this.entity.phoneNumber,
        email: this.entity.email,
        idKey: 260,
        externalId: this.entity.externalId,
        billMode: "Both",
        idValue: "00000",
        locale: "en",
        active: true,
        dateFormat: "dd MMMM yyyy",
        activationDate: this.entity.openingDate,
        flag: false,
        address: [
          concat(address, { addressType: "PRIMARY" }),
          concat(address, { addressType: "BILLING" }),
        ],
      };

      this.entity.clientData = clientData;
      if (this.entity.commisionModel === "Postpaid") {
        this.entity.commisionModel = 0;
      } else {
        this.entity.commisionModel = 1;
      }
      try {
        await this.$store.dispatch("entity/updateEntities", {
          id: this.id,
          data: this.entity,
        });

        if (this.updateResponse.resourceId) {
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Business Entity Updated Successfully!",
            type: "success",
          });
          this.nextTab();
          this.resetForm();
        }
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async getEntity() {
      try {
        await this.$store.dispatch("entity/setEntityDetail", this.id);
        this.entity = this.entityData;
        this.entity.openingDate = moment(this.entity.openingDate)
          .subtract(1, "M")
          .format("DD MMMM YYYY");
        this.parentEntities = this.entityTemplate.allowedParents;
        if (this.entity.commisionModel === "0") {
          this.entity.commisionModel = "Postpaid";
        } else {
          this.entity.commisionModel = "Prepaid";
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    resetForm() {
      this.entity = entityEmptyObj;
    },
    handlerCityChange() {
      this.cityTemplate();
    },
  },
  watch: {
    // "entity.officeType": function (newValue, oldValue) {
    //   this.parentEntities =
    //     _.filter(this.entityTemplate.allowedParents, {
    //       officeType: newValue,
    //     }) || [];
    //   if (newValue !== oldValue) {
    //     this.entity.parentId = this.entityData.parentId;
    //   }
    // },
    // "entity.parentId": function (neew, oold) {
    //   this.entity.parentId = neew;
    // },
    "entity.payment": function (newValue) {
      if (typeof newValue == "number") {
        this.entity.payment = this.entityTemplate.paymentTypeEnum[newValue - 1];
      }
    },
    entity(val) {
      if (val.dasTypeValue) {
        for (let temp of this.entityTemplate.segmentTypes) {
          if (temp.name == val.dasTypeValue) {
            this.entity.dasType = temp.id;

            delete this.entity.dasTypeValue;
          }
        }
      }
      if (val.subscriberDues != null) {
        this.entity.subscriberdues = val.subscriberDues;
        delete this.entity.subscriberDues;
      }
    },
  },
  mounted() {
    this.getTemplate();
    this.id = this.$route.params.id;
  },
  created() {},
};
</script>
<style>
.vue-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {
  width: 42%;
  left: 45px;
}
</style>
